module.exports = __webpack_public_path__ + "img/ico_rule_deco_right.3c0807c0.svg";